export const USER_ROLES = {
  FARMER: "farmer",
  AGRONOMIST: "agronomist",
};

export const USER_DOMAINS = {
  PRIVATE: "private_camvio",
  PUBLIC: "public_camvio",
};
